export default "__VITE_ASSET__Didm9hdQ__"